import React, { useEffect } from "react";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import founder1 from "../../images/About_US/founder1.png";
import founder2 from "../../images/About_US/founder2.png";
import vendorimg from "../../images/About_US/vendor.svg";
import partyimg from "../../images/About_US/party.svg";
import teamimg from "../../images/About_US/team1.svg";
import headerdesign from "../../images/header design.svg";
import trophy from "../../images/About_US/trophy.svg";
import likeicon from "../../images/About_US/like_icon.svg";
import { QueryBox } from "../../components/FAQ/Query";
import fb from "../../images/About_US/fb.svg";
// import twitter from "../../images/About_US/twitter.svg";
import linkedin from "../../images/linkedin.svg";
import instaicon from "../../images/instalogo.svg";
import ScrollTop from "../../components/ScrollToTop/ScrollTop";
import CreateWhatsappChatWidget from "../../components/WhatsAppIcon";
import "./aboutus.css";

function AboutUs() {
  const listenScrollEvent = () => {
    window.scrollY > 100
      ? (document.getElementById("return-to-top").style.display = "grid")
      : // setnavColor("#252734")
        (document.getElementById("return-to-top").style.display = "none");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  var url =
    "https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?3023";
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = url;
  var options = {
    enabled: true,
    chatButtonSetting: {
      backgroundColor: "#4dc247",
      ctaText: "",
      borderRadius: "25",
      marginLeft: "0",
      marginBottom: "50",
      marginRight: "50",
      position: "right",
    },
    brandSetting: {
      brandName: "SKYLARK",
      brandSubTitle: "Typically replies within a day",
      brandImg:
        "https://skylark-website-images.s3.ap-south-1.amazonaws.com/logo_res.png",
      welcomeText: "Hi there!\nHow can I help you?",
      messageText:
        "Hello team SKYLARK, I have an upcoming event.\nWhen can we schedule a meeting to discuss the details and requirements?",
      backgroundColor: "#8e0405",
      ctaText: "Start Chat",
      borderRadius: "25",
      autoShow: false,
      phoneNumber: "916201811075",
    },
  };
  s.onload = function () {
    CreateWhatsappChatWidget(options);
  };
  var x = document.getElementsByTagName("script")[0];
  x.parentNode.insertBefore(s, x);

  return (
    <div className="page_container aboutus_container">
      <div className="aboutus_page_header">
        <Navbar />

        <div className="pages_header_content">
          <p className="aboutus_header_text">About Us</p>

          <img className="header_design" src={headerdesign} />
        </div>
      </div>

      <div className="aboutus_page_container">
        <p className="brand_tagline">
          SKYLARK EVENTS AND DECOR - The EVENT that SMILES back{" "}
        </p>
        <p className="aboutus_text">
          As the winds of change blow across our economy, and brands become more
          market-driven than ever before, it is time for you to look beyond
          jargon-ridden advertising agencies and search out a marketing support
          organization that provides you with integrated solutions to strengthen
          your brand.
        </p>

        {/* <div className="aboutus_founder_images">
                <img src={founder1} className="founder1"/>
                <img src={founder2} className="founder2"/>
            </div> */}

        <p className="aboutus_text">
          Be it Relationship Marketing or a Direct Marketing Activity or a Below
          the-line Promotion, leading organizations across the country have
          entrusted us with a wide range of brand management responsibilities
          that have consolidated our reputation of being a single-window
          solution provider.
        </p>

        <div className="aboutus-client-text">
          <div>
            <h2>CHAMELEON EVENTS AND PROMOTIONS</h2>
            <p style={{ marginTop: "0" }}>Parent Company, 18yrs old</p>
          </div>
          <ScrollTop />

          <div>
            <h2>CHAMELEON INSTITUTE OF EVENTS</h2>
            <p style={{ marginTop: "0" }}>Since 2006</p>
          </div>

          <div style={{ display: "grid", justifyContent: "center" }}>
            <p
              style={{
                marginBottom: "0",
              }}
            >
              Type of Courses we provide
            </p>
            <ul>
              <li>Diploma in Event Management</li>
              <li>PGDM in Event Management</li>
            </ul>
          </div>

          <h5>
            To enquire about the course, click on WhatsApp chat or contact us on
            details provided
          </h5>
        </div>

        <div className="aboutus_cards">
          <div className="aboutus_card">
            <img className="card_image" src={vendorimg} />

            <p className="card_number">60+</p>
            <p className="card_text">Event vendors</p>
          </div>

          <div className="aboutus_card">
            <img className="card_image" src={partyimg} />
            <p className="card_number">50+</p>
            <p className="card_text">Matured Events</p>
          </div>

          <div className="aboutus_card">
            <img className="card_image" src={teamimg} />
            <p className="card_number">10+</p>
            <p className="card_text">Team</p>
          </div>
        </div>

        <div className="aboutus_services">
          <p className="aboutus_services_heading">Our Services</p>

          <div className="aboutus_services_cards">
            <div className="service_card">
              <p className="service_card_text">Flowers and Decor </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Dining and Caterers </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Arranging Transportation </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">
                Arranging Celebrity / Guest Speakers{" "}
              </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Event Monitoring </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Video & Photography </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Wedding Stage Effects </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Selecting Venues / Vendors </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">License Arrangment</p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Lighting </p>
            </div>

            <div className="service_card">
              <p className="service_card_text">Tenting </p>
            </div>
          </div>
        </div>
      </div>

      <div className="we_offer">
        <div className="trophy_text">
          <div className="trophy_img_cont">
            <img src={trophy} className="trophy_image" />
          </div>

          <p className="we_offer_text">
            We offer everything a traditional agency can offer, and much more.{" "}
          </p>
        </div>
      </div>

      <div className="aboutus_page_container">
        <div className="our_team">
          <p className="our_team_heading">Our Founder</p>

          <div className="founders">
            <div className="founder1">
              <img src={founder1} alt="Deepak Prakash" />
              <p className="founder1_name"> Deepak Prakash</p>
            </div>

            {/* <div className="founder2">
              <img src={founder2} alt="Shubham Kumar Singh" />
              <p className="founder2_name">Shubham Kumar Singh</p>
            </div> */}
          </div>

          <div className="our_team_bottom">
            <p className="aboutus_text4">
              We look forward to working with you and wish your brand the very
              best!
            </p>

            <img src={likeicon} />
          </div>
        </div>

        <div className="aboutus_bottom_cont">
          {/* <QueryBox /> */}

          <div className="social_icons">
            <p className="aboutus_follow">Follow Us</p>
            <p className="aboutus_updates"> To Get our Latest Updates </p>

            <div className="social_media_icons">
              <a href="https://www.facebook.com/info.skylarkevents/">
                {" "}
                <img src={fb} />
              </a>
              <a href="https://www.linkedin.com/company/skylark-events-decor/">
                <img src={linkedin} />
              </a>
              <a href="https://instagram.com/skylark.events_decor?igshid=YmMyMTA2M2Y=">
                <img src={instaicon} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AboutUs;
